import { JsonFormsRendererRegistryEntry } from '@jsonforms/core';
import { UnsupportedControl } from './UnsupportedControl';
import { GroupControl } from './GroupControl';
import { TextControl } from './TextControl';

/**
 * All renderers for supporting dynamic forms on RN.
 */
export const renderers: JsonFormsRendererRegistryEntry[] = [TextControl, GroupControl, UnsupportedControl];
